﻿import React from 'react';
import { MediumLarge, MyOffer } from '../tileTypes';
import { Button } from '../../Button/Button';
import { MediumLargeTileWrapper } from '../TileWrappers';
import OfferProgress from '../../MyOffers/OfferProgress';
import { GameGraphics } from '../../GameGraphics/GameGraphics';

type MediumLargeOfferProps = MediumLarge & MyOffer & React.HTMLAttributes<HTMLElement>

const MediumLargeOfferTile = (props: MediumLargeOfferProps) => {
  const { offerProgress, gameGraphics, remainingDays, title, moreInfoCta, teaserImage, applicableProducts, expiryTimeCountDown, className, serviceSubType } = props;

  return <MediumLargeTileWrapper className={className}>
    <div className={'relative rounded-t-32'}>
      {gameGraphics
        ? <div className={'absolute inset-x-0 -top-12 bottom-0 pt-12 overflow-hidden'}>
          <GameGraphics rounded={'rounded-t-32 rounded-b-0'} backgroundUrl={gameGraphics.background as string | undefined} foregroundUrl={gameGraphics.foreground ?? ''} foregroundStyle={'scale-[2] top-70'} />
        </div>
        : <img className={'w-full h-full rounded-t-32'} src={teaserImage.src} alt={teaserImage.alt}/> }
      {offerProgress && <OfferProgress remainingDays={remainingDays} applicableProducts={applicableProducts} expiryTimeCountDown={expiryTimeCountDown} serviceSubType={serviceSubType} {...offerProgress }/>}
    </div>
    <div className={'px-16 pb-40'}>
      <div className={'text-20 font-bold'}>
        {title}
      </div>
      <div className={'text-12'} dangerouslySetInnerHTML={{ __html: props.keyTermsAndConditions }}></div>
    </div>
    <div className={'absolute bottom-0 w-[max-content] translate-y-1/2 flex gap-12 left-1/2 -translate-x-1/2'}>
      {
        moreInfoCta &&
          <Button className={'block min-w-72'} size={'medium'} text={moreInfoCta.text ?? 'Læs mere'} as={'a'} href={moreInfoCta.url} variant={moreInfoCta.attributes?.class?.includes('primary') ? 'primary' : 'secondary'}/>
      }
    </div>
  </MediumLargeTileWrapper>;
};

export default MediumLargeOfferTile;
